import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <h3 className="font-heading text-3xl font-bold mb-4">
              {t('footer.brand')}
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs">
              {t('footer.description')}
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-400 flex items-center justify-center cursor-pointer hover:border-background-50 transition-colors">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-400 flex items-center justify-center cursor-pointer hover:border-background-50 transition-colors">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-400 flex items-center justify-center cursor-pointer hover:border-background-50 transition-colors">
                <i className="ri-telegram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-400 flex items-center justify-center cursor-pointer hover:border-background-50 transition-colors">
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-5">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">
              {t('footer.categories')}
            </h4>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-2.5">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-300 hover:text-background-50 whitespace-nowrap cursor-pointer transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">
              {t('footer.quick_links')}
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 whitespace-nowrap cursor-pointer transition-colors">
                {t('nav.home')}
              </Link>
              <Link to="/guida-itaobuy-spreadsheet-italiano" className="text-sm text-foreground-300 hover:text-background-50 whitespace-nowrap cursor-pointer transition-colors">
                {t('nav.guida')}
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-300 hover:text-background-50 whitespace-nowrap cursor-pointer transition-colors"
              >
                kaspreadsheet.com
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">
              {t('nav.home')}
            </Link>
            <Link to="/guida-itaobuy-spreadsheet-italiano" className="text-xs text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">
              {t('nav.guida')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}